document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }

  if (header && header.dataset.sticky === 'true') {
    const setHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-category-filter]').forEach((filterSection) => {
    const input = filterSection.querySelector('[data-category-filter-input]');
    const cards = Array.from(filterSection.querySelectorAll('[data-category-card]'));
    const status = filterSection.querySelector('[data-category-filter-status]');

    if (!input || !cards.length) return;

    const normalize = (value) => value
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const updateCategories = () => {
      const query = normalize(input.value.trim());
      let visibleCount = 0;

      cards.forEach((card) => {
        const matches = !query || normalize(card.dataset.searchText || '').includes(query);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (status) {
        status.textContent = query
          ? `${visibleCount} passende ${visibleCount === 1 ? 'Kategorie' : 'Kategorien'} gefunden.`
          : '';
      }
    };

    input.addEventListener('input', updateCategories);
  });

  document.querySelectorAll('[data-random-products]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const products = Array.from(carousel.querySelectorAll('[data-random-product]'));
    const previousButton = carousel.querySelector('[data-carousel-prev]');
    const nextButton = carousel.querySelector('[data-carousel-next]');

    if (!track || !products.length) return;

    products
      .map((product) => ({ product, order: Math.random() }))
      .sort((a, b) => a.order - b.order)
      .forEach(({ product }) => track.appendChild(product));

    const scrollProducts = (direction) => {
      const item = track.querySelector('[data-random-product]');
      const distance = item ? item.getBoundingClientRect().width + 16 : 280;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previousButton?.addEventListener('click', () => scrollProducts(-1));
    nextButton?.addEventListener('click', () => scrollProducts(1));
  });

  document.querySelectorAll('[data-smart-contact]').forEach((contactSection) => {
    const typeSelect = contactSection.querySelector('[data-contact-type]');
    const conditionalGroups = contactSection.querySelectorAll('[data-contact-group]');

    if (!typeSelect || !conditionalGroups.length) return;

    const queryValue = new URLSearchParams(window.location.search).get('anfrage');
    const queryMap = {
      heizsysteme: 'Heizsysteme Löschmann',
      energiemesstechnik: 'Energiemesstechnik',
      immobilienmanagement: 'Immobilienmanagement Löschmann',
      hausmeisterservice: 'Hausmeisterservice',
      allgemein: 'Allgemeine Anfrage'
    };

    if (queryValue && queryMap[queryValue]) {
      typeSelect.value = queryMap[queryValue];
    }

    const updateContactFields = () => {
      const selectedGroup = {
        'Heizsysteme Löschmann': 'heizsysteme',
        Energiemesstechnik: 'energiemesstechnik',
        'Immobilienmanagement Löschmann': 'immobilienmanagement',
        Hausmeisterservice: 'hausmeisterservice'
      }[typeSelect.value];

      conditionalGroups.forEach((group) => {
        const isActive = group.dataset.contactGroup === selectedGroup;
        group.hidden = !isActive;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !isActive;
        });
      });
    };

    updateContactFields();
    typeSelect.addEventListener('change', updateContactFields);
  });
});
